import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { I18nProvider, installStaleChunkReload } from '@servicesai/ui';
import '@servicesai/ui/styles.css';
import '@xyflow/react/dist/style.css';
import { App } from './App.js';
import { ConsoleErrorBoundary } from './components/ConsoleErrorBoundary.js';
import { CxoneAgentProvider } from './cxone/CxoneAgentProvider.js';

// Nearly every page here is a dynamic import, so a console left open across a
// deploy asks for chunks the new pods no longer serve.
installStaleChunkReload();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
    mutations: { retry: 0 },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConsoleErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <I18nProvider defaultLang={(import.meta.env.VITE_DEFAULT_LOCALE as 'ar' | 'en') ?? 'en'}>
          <BrowserRouter>
            <CxoneAgentProvider>
              <App />
            </CxoneAgentProvider>
          </BrowserRouter>
        </I18nProvider>
      </QueryClientProvider>
    </ConsoleErrorBoundary>
  </StrictMode>,
);
